export default __webpack_public_path__ + "static/media/36I-114285_-20960_0.4c4063ed.jpg";